import { LeagueId } from '../types';

export type UserParticipationFields = {
  participacion?: Partial<Record<LeagueId, boolean>>;
};

/** Por defecto participa; solo `false` explícito lo retira del torneo. */
export function isUserParticipating(
  user: UserParticipationFields,
  league: LeagueId
): boolean {
  return user.participacion?.[league] !== false;
}

export function filterParticipatingUsers<T extends UserParticipationFields>(
  users: T[],
  league: LeagueId
): T[] {
  return users.filter((user) => isUserParticipating(user, league));
}

/** Participantes visibles en rankings: activos en la liga y con nombre de perfil (no correo). */
export function toRankingParticipants(
  users: { uuid: string; name?: string; email?: string }[]
): { uuid: string; name: string }[] {
  return users
    .filter((user) => Boolean(user.name?.trim() && user.email))
    .map((user) => ({
      uuid: user.uuid,
      name: user.name!.trim(),
    }));
}

export function getParticipationLabel(
  user: UserParticipationFields,
  league: LeagueId
): string {
  return isUserParticipating(user, league) ? 'Activo' : 'Retirado';
}
